import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import dayjs from 'dayjs';
import React, { FC } from 'react';

import { checkDateIsValid } from '../../../../common/helpers';
import { DocUploadedUser } from '../../Registration.interfaces';
import styles from './UploadedDoc.module.scss';

type Props = {
  doc: DocUploadedUser;
  onDownload: (fileId: string) => void;
  onSetActiveDoc: (fileId: string) => void;
  onOpenDeleteModal: () => void;
  disableEdit: boolean;
};

export const UploadedDoc: FC<Props> = ({
  doc,
  onDownload,
  onSetActiveDoc,
  onOpenDeleteModal,
  disableEdit,
}) => {
  const onOpenDelete = (fileId: string) => {
    onSetActiveDoc(fileId);
    onOpenDeleteModal();
  };

  return (
    <div className={styles.doc}>
      <h5 className={styles['doc__title']}>{doc.docTypeName}</h5>

      <div className={styles['doc__items']}>
        <div className={styles['doc__item']}>
          <label htmlFor="">Номер документа</label>
          <p>{doc.number || '-'}</p>
        </div>

        {/* <Flex gap={10} justify='space-between'> */}
        {doc.date && (
          <div className={styles['doc__item']}>
            <label htmlFor="">Дата</label>
            <p>{dayjs(doc.date).format('DD.MM.YYYY')}</p>
          </div>
        )}

        {doc.validTo && (
          <div className={styles['doc__item']}>
            <label htmlFor="">Дата окончания</label>
            <p>
              {checkDateIsValid(doc.validTo)
                ? dayjs(doc.validTo).format('DD.MM.YYYY')
                : '-'}
            </p>
          </div>
        )}
        {/* </Flex> */}

        {doc.comment && (
          <div className={styles['doc__item']}>
            <label htmlFor="">Комментарий</label>
            <p>{doc.comment}</p>
          </div>
        )}
      </div>

      <div className={styles.buttons}>
        <Button
          icon={<DownloadOutlined />}
          variant="text"
          onClick={() => onDownload(doc.fileId as string)}
        >
          Скачать
        </Button>

        {!doc.blocked && (
          <Button
            onClick={() => onOpenDelete(doc.fileId as string)}
            icon={<DeleteOutlined />}
            color="danger"
            type="link"
            variant="outlined"
            disabled={disableEdit}
          >
            Удалить
          </Button>
        )}
      </div>
    </div>
  );
};
